// Singleton-Bus für die aktive CompassRose-Instanz.
//
// Warum: MapPage will im Ride-Mode die Rose automatisch in den Heading-Modus
// schalten (User-Wunsch: "im ride mode standard handy mit kompass drehen").
// Gleiches Pattern wie mapBus / positionBus / locateControlBus — kein State-
// Framework nötig weil's immer exakt 1 Rose gibt.

import type { CompassRose } from './CompassRose';

let current: CompassRose | null = null;
const listeners = new Set<(c: CompassRose | null) => void>();

export const compassBus = {
  get(): CompassRose | null {
    return current;
  },
  set(c: CompassRose | null): void {
    if (current === c) return;
    current = c;
    listeners.forEach((fn) => fn(c));
  },
  subscribe(fn: (c: CompassRose | null) => void): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};
